import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-s3auth',
  templateUrl: './s3auth.component.html',
  styleUrls: ['./s3auth.component.css']
})
export class S3authComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }


  requestData =`
    {
      "access_key_id": "XXXXXXXXXXXXX",
      "secret_access_key": "XXXXXXXXXXXX",
      "region": "XXXXXX",
      "bucket_name": "dev-test"
    }`




  sucessData =`
  {
    "data": null,
    "message": "S3 authenticated successfully"
  }
  `

  Error5x =`
  {
    "error": {},
    "message": "string"
  }
  `

  Error41x =`
  {
    "error": "NotFound: Not Found\n\tstatus code: 404, request id: 6BFV8RGCJHP0KFJZ, host id: A2yScM9nAHPoNCNfn1M+stX5wvANt6x17gVeZzKUeGm8ld/wdviAS5y0dNgJ/OzQL9lCKpGw7IQ=",
    "message": "Error Authenticating, Please check your credentials"
  }

  `
  Error42x =`
  {
    "error": "Forbidden: Forbidden\n\tstatus code: 403, request id: FBMPWTCM91HV6GTG, host id: ZJPB65o76YCLr67xKVhjPWvVyCq2M9NSUH0pMR4TVDinKzhw7ZB0VRv8nVN+C4rrsaggJr8MWtc=",
    "message": "Error Authenticating, Please check your credentials"
  }
  
  `

  Error43x =`
  {
    "error": "access_key_id is the required field",
    "message": "access_key_id is the required field"
  }`
  
  Error44x =`
  {
    "error": "RequestError: send request failed\ncaused by: Head \"https://cmw-optimus-video-bucket.s3.us-east-12.amazonaws.com/\": dial tcp: lookup cmw-optimus-video-bucket.s3.us-east-12.amazonaws.com on 169.254.78.1:53: no such host",
    "message": "Error Authenticating, Please check your credentials"
  }
  
  `

  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `


  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }

  

}
